import { BaseAPI } from "@utils/base-api";

export class CatsAPI extends BaseAPI {

}
